export default "__VITE_ASSET__DQ70C0HA__"